import gql from 'graphql-tag';

const bulkAllowPendingOfferMutation = gql`
  mutation bulkAllowPendingOffer($input: BulkAllowPendingOfferInput!) {
    bulkAllowPendingOffer(input: $input) {
      success
      errors
    }
  }
`;

export default bulkAllowPendingOfferMutation;
